import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";

/** The kit's card (`.card`): `flat` drops the shadow, `pad` pads it for content with no head. */
export function Card({ flat = false, pad = false, className, children, ...rest }: HTMLAttributes<HTMLElement> & { flat?: boolean; pad?: boolean }) {
  return (
    <section className={cx("card", flat && "flat", pad && "pad", className)} {...rest}>
      {children}
    </section>
  );
}

/** A card's head: its title, an optional line under it, and an action at the right. */
export function CardHead({ title, sub, action }: { title: ReactNode; sub?: ReactNode; action?: ReactNode }) {
  return (
    <div className="card-h">
      <div>
        <h2>{title}</h2>
        {sub ? <div className="sub">{sub}</div> : null}
      </div>
      {action}
    </div>
  );
}

